import React from "react";
import { withRouter } from "react-router-dom";

import { createBrowserHistory } from "history";

function Admin() {
  const history = createBrowserHistory();

  const onLogin = function () {
    const location = {
      pathname: "/Login",
      state: { fromDashboard: true },
    };

    history.push(location);

    window.location.reload();
  };

  const onRegister = function () {
    const location = {
      pathname: "/Register",
      state: { fromDashboard: true },
    };

    history.push(location);

    window.location.reload();
  };

  return (
    <div className="Card u-marginAuto u-marginBottom20">
      <div className="Card-content u-marginTop10">
        <h2 className="Card-title u-marginBottom20">
          Welcome to the Admin Page
        </h2>
        <input
          type="Submit"
          className="Button"
          value="Login"
          onClick={onLogin}
        />
        <br />
        <input
          type="Submit"
          className="Button"
          value="Register"
          onClick={onRegister}
        />
      </div>
    </div>
  );
}

export default withRouter(Admin);
